export enum OtpPurpose {
  PASSWORD_RESET = 'PASSWORD_RESET',
  ACCOUNT_ACTIVATION = 'ACCOUNT_ACTIVATION',
  TWO_FACTOR_AUTH = 'TWO_FACTOR_AUTH'
}

export interface GenerateOtpRequest {
  email: string;
  purpose: OtpPurpose;
}

export interface VerifyOtpRequest {
  email: string;
  otpCode: string;
  purpose: OtpPurpose;
}

export interface ResendOtpRequest {
  email: string;
  purpose: OtpPurpose;
}

export interface ResetPasswordRequest {
  email: string;
  otpCode: string;
  newPassword: string;
  confirmPassword: string;
}

export interface OtpResponse {
  message: string;
  expiresInMinutes: number;
}

export interface VerifyOtpResponse {
  valid: boolean;
  message: string;
}
